<template>
  <div classname="ps-sidebar ps-sidebar--home">
    <aside class="ps-widget ps-widget--popular-posts">
      <h4 class="ps-widget__heading">
        <span v-if="lang === 'es'">Publicaciones recientes</span>
        <span v-else>Recent Posts</span>
      </h4>
      <div class="ps-widget__content">
        <article class="ps-post ps-post--horizontal small" v-for="post in allPosts" v-bind:key="post._id">
          <div class="ps-post__thumbnail">
            <a :href="`/blog/${post.key}?lang=${lang}`" class="ps-post__overlay"></a>
            <img :src="post.image || defaultImage" :alt="getTextByLang(post, 'title', lang)">
          </div>
          <div class="ps-post__wrapper">
            <div class="ps-post__content">
              <h4 class="ps-post__title">
                <a :href="`/blog/${post.key}?lang=${lang}`" class="">
                  {{ getTextByLang(post, 'title', lang) }}
                </a>
              </h4>
              <div class="ps-post__meta">
                <span class="ps-post__posted">{{ moment.utc(post.publishing_date).format('LL') }}</span>
              </div>
            </div>
          </div>
        </article>
      </div>
    </aside>
    <aside class="ps-widget ps-widget--categories">
      <h4 class="ps-widget__heading">
        <span v-if="lang === 'es'">Categorias</span>
        <span v-else>Categories</span>
      </h4>
      <div class="ps-widget__content">
        <ul class="ps-list">
          <li>
            <a href="/blog/category/all">
              <div v-if="lang === 'es'">Todos</div>
              <div v-else>All</div>
              <span>{{totalNonCategoryPost}}</span>
            </a>
          </li>
          <li v-for="category in categories" v-bind:key="category._id">
            <a :href="'/blog/category/'+category.key">
              <div>{{ getTextByLang({category}, 'category', lang) }}</div>
              <span>{{ category.total_blogs }}</span>
            </a>
          </li>
        </ul>
      </div>
    </aside>
    <aside class="ps-widget ps-widget--follow-me pt-4">
      <h4 class="ps-widget__heading">
        <span v-if="lang === 'es'">S&iacute;guenos</span>
        <span v-else>Follow Us</span>
      </h4>
      <div class="ps-widget__content">
        <a href="https://www.facebook.com/indiefyapp" target="_blank">Facebook</a>
        <a href="https://twitter.com/indiefyapp" target="_blank">Twitter</a>
        <a href="https://www.youtube.com/channel/UCIb1zDHx1LGw0HB59zbmWIA" target="_blank">Youtube</a>
        <a href="https://www.instagram.com/indiefyapp" target="_blank">Instagram</a>
      </div>
    </aside>
  </div>
</template>
<script>
import Filters from '../utils/filters'
export default {
  name: 'SideWidget',
  data () {
    return {
      defaultImage: '/static/img/blog/default-banner.jpg'
    }
  },
  created: function () {
    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.lang !== 'es' && this.lang !== 'en') {
      this.lang = 'en'
    }
  },
  props: ['moment', 'lang', 'allPosts', 'totalNonCategoryPost', 'categories'],
  methods: {
    getTextByLang: Filters.getTextByLang
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/sass/blog/vars.scss";
@import "../../assets/sass/blog/list.scss";
@import "../../assets/sass/blog/attraction.scss";
@import "../../assets/sass/blog/widget.scss";
</style>



// WEBPACK FOOTER //
// src/components/blog-components/SideWidget.vue